import BaseApi from './base.api';

export interface LegalDocumentResponse {
  content: string;
  updatedAt: string;
}

class LegalApi extends BaseApi {
  constructor() {
    super();
  }

  public getTermsAndConditions = (): Promise<LegalDocumentResponse> => {
    return this.get('/legal/terms');
  };

  public getPrivacyPolicy = (): Promise<LegalDocumentResponse> => {
    return this.get('/legal/privacy');
  };
}

export const legalApi = new LegalApi();
export const getTermsAndConditions = legalApi.getTermsAndConditions;
export const getPrivacyPolicy = legalApi.getPrivacyPolicy;
